export default "\r\n<app-city-list></app-city-list>\r\n\r\n\r\n";